// 地图静态资源(底图 GeoJSON、震度图标、走时表等)的地址解析:
// 开发环境或未配置 ASSETS_CDN 时走本地相对路径(由 Rails 从 public/ 提供),
// 生产环境配置 ASSETS_CDN(布局内联脚本注入)后从 CDN 拉取。
// ASSETS_CDN 支持三种写法:https://cdn.example.com、//cdn.example.com、
// cdn.example.com(无协议时自动补全 https://)。
// 注意:CDN 需返回 CORS 响应头,底图 GeoJSON 的 fetch 与震度图标的
// crossOrigin 加载都依赖它。
export function getAssetUrl(path) {
  if (window.BACKEND_ENV === "development" || !window.ASSETS_CDN) {
    return `/${path}`
  }
  const cdn = String(window.ASSETS_CDN).replace(/\/+$/, "")
  if (/^https?:\/\//i.test(cdn) || cdn.startsWith("//")) {
    return `${cdn}/${path}`
  }
  return `https://${cdn}/${path}`
}
